"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.render = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactGa = _interopRequireDefault(require("react-ga"));

var _ContainerLoader = _interopRequireDefault(require("./layout/ContainerLoader.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * @param {Object}          options
 * @param {string | Object} options.target - a <div> id or a DOM element, as returned by ReactDOM.findDOMNode()
 * @param {boolean}         options.disableGoogleAnalytics - Disable Google Analytics
 * @param {boolean}         options.showControlMenu - Show menu with sorting, filtering and download options
 * @param {function}        options.fail - Callback to run if the AJAX request to the server fails. (jqXHR, textStatus)
 * @param {function}        options.render - Callback to run after each render
 * @param {boolean}         options.showAnatomogram - optionally hide the anatomogram
 * @param {boolean}         options.isWidget
 * @param {string}          options.atlasUrl - Atlas host and path with protocol and port
 * @param {string}          options.inProxy - Inbound proxy to pull assets from outside your domain
 * @param {string}          options.outProxy - Outbound proxy for links that take you outside the current domain
 * @param {string}          options.experiment
 * @param {Object|string}   options.query - Query object or relative URL endpoint to source data from:
 *                              e.g. json/experiments/E-PROT-1, /json/genes/ENSG00000005801, /json/genesets/GO:0000001
 *                                   json/baseline_refexperiment?geneQuery=…, /json/baseline_experiments?geneQuery=…
 * @param {string}                              options.query.species
 * @param {{value: string, category: string}[]} options.query.gene
 * @param {{value: string, category: string}[]} options.query.condition
 * @param {string}                              options.query.source
 */
var DEFAULT_OPTIONS = {
  showAnatomogram: true,
  isWidget: true,
  disableGoogleAnalytics: false,
  showControlMenu: true,
  atlasUrl: "https://www.ebi.ac.uk/gxa/",
  inProxy: "",
  outProxy: "",
  experiment: ""
};

var ExpressionAtlasHeatmap = function ExpressionAtlasHeatmap(options) {
  return (
    /*#__PURE__*/
    // The wrapping div is important to determine the width of the heatmap and know if the labels are going to be
    // rotated, so that we can set sensible margin sizes. See HeatmapCanvas.js
    _react["default"].createElement("div", {
      className: "gxaHeatmapContainer"
    }, /*#__PURE__*/_react["default"].createElement(_ContainerLoader["default"], _extends({}, DEFAULT_OPTIONS, options, {
      source: typeof options.query === "string" ? {
        endpoint: options.query,
        params: {}
      } : {
        endpoint: resolveEndpoint(options.experiment),
        //the webapp wants "geneQuery" and "conditionQuery" as parameters but in the API offering query.gene and
        // query.condition felt nicer
        params: options.query ? Object.entries(options.query).map(function (p) {
          return ["gene", "condition"].includes(p[0]) ? [p[0] + "Query", p[1]] : p;
        }).reduce(function (acc, o) {
          acc[o[0]] = o[1];
          return acc;
        }, {}) : {}
      }
    })))
  );
};

exports["default"] = ExpressionAtlasHeatmap;

var render = function render(options) {
  var _options$disableGoogl = options.disableGoogleAnalytics,
      disableGoogleAnalytics = _options$disableGoogl === void 0 ? false : _options$disableGoogl,
      _options$render = options.render,
      render = _options$render === void 0 ? function () {} : _options$render,
      target = options.target;

  _reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(ExpressionAtlasHeatmap, options), typeof target === "string" ? document.getElementById(target) : target, render);

  if (!disableGoogleAnalytics) {
    _reactGa["default"].initialize("UA-37676851-1", {
      gaOptions: {
        name: "atlas-highcharts-widget"
      }
    });

    _reactGa["default"].pageview(window.location.pathname);
  }
};

exports.render = render;

function resolveEndpoint(experiment) {
  return !experiment ? "json/baseline_experiments" : experiment === "reference" ? "json/baseline_refexperiment" : "json/experiments/".concat(experiment);
}